import { render } from "./Izin.vue?vue&type=template&id=95ad4b20"
import script from "./Izin.vue?vue&type=script&lang=js"
export * from "./Izin.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__